import { InjectionToken } from '@angular/core';
import { AuthRepository } from 'src/app/core/repositories/auth.repository';

export const authInjectionToken: InjectionToken<AuthRepository> =
  new InjectionToken<AuthRepository>('Auth Repository');
